import { IGenericResponse } from './../../../common/interface/generic-response.interface';
import { IFeature, IPermissions } from './../../../common/interface/rbac.interface';
import { BaseHttpService } from 'src/app/shared/services/base-http/base-http.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map, of } from 'rxjs';

const FEATURES = "platform/features";
const PERMISSIONS = "platform/permissions";
const DEFAULT_ROLES: string[] = ['Library', 'Projects'];

@Injectable({
  providedIn: 'root'
})
export class RbacService {

  _featureList: IFeature[];
  permissionsData: IPermissions = null;
  private _currentFeature: string = null;
  actionDataForFeature = new Map();
  private _isPermissionUpdated: BehaviorSubject<boolean>;

  constructor(private readonly httpService: BaseHttpService) { 
    this._isPermissionUpdated = new BehaviorSubject(false);
  }

  public getAllFeatures(): Observable<IFeature[]> {
    if(this._featureList?.length) {
      return of(this.featureList);
    }
    return this.httpService.get(FEATURES).pipe(map((res: IGenericResponse) => {
      if(res) {
        if(res.data?.length) {
          this.featureList = res?.data;
          return this.featureList;
        }
      }
    }))
  }

  public getPermissionsForFeature(id?, packageId?): Observable<IPermissions> {
    if(this.permissionsData?.featureName.toLowerCase() === this.currentFeature) {
      return of(this.permissionsData);
    }
    const searchParams=new URLSearchParams()
    
    if(packageId){
      searchParams.append('packageId', packageId)
    }
    const url = `${PERMISSIONS}/${id}?`+ searchParams.toString()
    return this.httpService.get(url).pipe(map((res: IGenericResponse) => {
      if(res) {
        this.permissionsData = res.data;
        this.permissionsData.actions = [...new Set([...res.data.actions, ...DEFAULT_ROLES])];
        return this.permissionsData;
      }
    }))
  }

  public getPermissionsForFeatureProject(id?, projectId?): Observable<IPermissions> {
    if(this.permissionsData?.featureName.toLowerCase() === this.currentFeature) {
      return of(this.permissionsData);
    }
    const searchParams=new URLSearchParams()
    
    if(projectId){
      searchParams.append('projectId', projectId)
    }
    const url = `${PERMISSIONS}/${id}?`+ searchParams.toString()
    return this.httpService.get(url).pipe(map((res: IGenericResponse) => {
      if(res) {
        this.permissionsData = res.data;
        this.permissionsData.actions = [...new Set([...res.data.actions, ...DEFAULT_ROLES])];
        return this.permissionsData;
      }
    }))
  }

  public set currentFeature(val: string) {
    this._currentFeature = val.toLowerCase();
  }

  public get currentFeature(): string {
    return this._currentFeature;
  }

  public set featureList(val: IFeature[]) {
    this._featureList = val;
  }

  public get featureList(): IFeature[] {
    return this._featureList;
  }

  public setActionDataForFeature(data) {
    this.actionDataForFeature.set(data?.featureName?.toLowerCase(), data?.actions);
  }

  public getActionDataForFeature(name) : string[]{
    if(this.actionDataForFeature.has(name)) {
      return this.actionDataForFeature.get(name);
    };
  }

  public getIsPermissionUpdated(): Observable<boolean>  {
    return this._isPermissionUpdated as Observable<boolean>;
  }
  
  public setIsPermissionUpdated(value: boolean) {
    this._isPermissionUpdated.next(value)
  }
}
